import React from 'react';

/**
 * Sign in / Sign up toggle for the auth modal.
 */
const AuthModeTabs = ({ active, onSelect }) => (
  <div className="login-mode-tabs" role="tablist" aria-label="Account mode">
    <button
      type="button"
      role="tab"
      aria-selected={active === 'signin'}
      className={`login-mode-tab${active === 'signin' ? ' is-active' : ''}`}
      onClick={() => onSelect('signin')}
    >
      Sign in
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={active === 'signup'}
      className={`login-mode-tab${active === 'signup' ? ' is-active' : ''}`}
      onClick={() => onSelect('signup')}
    >
      Sign up
    </button>
  </div>
);

export default AuthModeTabs;
